import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 23 * 3600 + 59 * 60 + 51;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  return <div className="flex items-center justify-center gap-3 rounded-xl border border-court-950/10 bg-bone px-4 py-2.5" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-45" data-mp="324rjvzviqljw">
      <ClockIcon className="h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-46" data-mp="15bg4oelhfb8a" />
      <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-court-950" data-id="element-47" data-mp="159bxnnsadw3s">
        Ends in
      </span>
      <span className="text-center" data-id="element-48" data-mp="t23epmacrth5">
        <span className="block font-display text-lg font-black leading-none tabular-nums text-clay" data-id="element-49" data-mp="t125lncwdh22">
          {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </span>
        <span className="mt-0.5 block text-[8px] font-semibold uppercase tracking-[0.22em] text-court-600" data-id="element-50" data-mp="12s56ao1wzu0t">
          Hours · Min · Sec
        </span>
      </span>
    </div>;
}